import { FunctionComponent } from "react";
import { Text } from "@kanda-libs/ks-design-library";
import useJobPaymentsProps from "components/job/JobLayout/JobPayments/useJobPaymentsProps";
import Payment from "components/job/JobLayout/JobPayments/Payment";

const JobPayments: FunctionComponent = function () {
  const { payments, credits, isLoading } = useJobPaymentsProps();

  return (
    <div className="flex flex-col mb-6">
      <Text
        text="Payments"
        className="mb-6 text-16-20-em text-neutral-800"
        isLoading={isLoading}
      />
      {!payments ? (
        <Text
          text="No payment data available"
          className="text-16-20 text-neutral-800"
          isLoading={isLoading}
        />
      ) : (
        payments.map((payment) => (
          <Payment
            credits={credits || []}
            payment={payment}
            key={payment?.id}
          />
        ))
      )}
    </div>
  );
};

export default JobPayments;
